<template>
  <div class="demo-app">
    <a-config-provider>
      <router-view />
    </a-config-provider>
  </div>
</template>

<script lang="ts" >
import { computed, defineComponent, ref } from 'vue'
import { useMyStore } from './store'
import GMap from '/@/components/GMap.vue'
// import zhCN from 'ant-design-vue/es/locale/zh_CN'
// import moment from 'moment'
// import 'moment/locale/zh-cn'
// moment.locale('zh-cn', {
//   months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
//   weekdaysMin: ['日', '一', '二', '三', '四', '五', '六']
// })

// zhCN.DatePicker!.lang.monthFormat = 'M月'
// export default defineComponent({
//   name: 'App',
//   components: { GMap },

//   setup () {
//     const locale: Object = ref(zhCN)
//     const store = useMyStore()

//     return { locale }
//   }
// })
</script>
<style lang="scss" scoped>
.demo-app {
  width: 100%;
  height: 100%;

  .map-wrapper {
    height: 100%;
    width: 100%;
  }
}
</style>

<style lang="scss">
#demo-app {
  width: 100%;
  height: 100%
}

.ant-popover-placement-top>.ant-popover-content>.ant-popover-arrow,
.ant-popover-placement-topLeft>.ant-popover-content>.ant-popover-arrow,
.ant-popover-placement-topRight>.ant-popover-content>.ant-popover-arrow {
  border-right-color: rgb(44, 48, 63) !important;
  border-bottom-color: rgb(44, 48, 63) !important;
}

.ant-popover-inner {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgb(44, 48, 63) !important;
}

.ant-popover-inner-content .ant-popover-message {
  color: #fff !important;
}
::v-deep(.ant-calendar-picker-clear ){
  background: #2C303F;
  color: #fff;
}
</style>
